
if (!customElements.get('bfcm-deals')) {
  class BfcmDeals extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 4.6);
      this._swiperContainer = this.querySelector('.swiper');

      if (this.querySelectorAll('.swiper-slide').length <= 4) {
        const isMobile = `(max-width: 768px)`;
        const isMobileMQL = window.matchMedia(isMobile);

        isMobileMQL.addEventListener('change', (event) => {
          if (event.matches) {
            this.createSlider();
          } else if (this.mySwiper) {
            this.destroySwiper();
          }
        });

        if (isMobileMQL.matches) this.createSlider();
      } else {
        this.createSlider();
      }
    }

    createSlider() {
      const nextButton = this.querySelector('.swiper-btn-next');
      const prevButton = this.querySelector('.swiper-btn-prev');
      const pagination = this.querySelector(`.swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerView: '1.5',
        spaceBetween: 16,
        loop: false,
        direction: "horizontal",
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          400: {
            slidesPerView: 1.6,
            spaceBetween: 16,
          },
          589: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          769: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 3.6,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4.6,
            spaceBetween: 20,
          },
        }
      });
    }

    destroySwiper() {
      this._swiperInstance.destroy();
    }
  }

  customElements.define('bfcm-deals', BfcmDeals);
}